<script setup>
import { api } from '~/apis'
import { useSpotStore } from '~/store/spot'

const spot = useSpotStore()
async function cancelOrderAll() {
  const { success } = await api.post('trade/order/cancelAll', { json: {} }).json()
  if (success) {
    return true
  }
}
</script>

<template>
  <CommonXModal v-model:show="spot.modal.cancelAll" :title="$t('全部撤单')" :ok="cancelOrderAll" @closed="spot.modal.cancelAll = false">
    {{ $t('确认撤销全部当前委托？') }}
  </CommonXModal>
</template>
